import * as Yup from 'yup';
import {PRICE_COMPONENT_MODES} from './constants';

export const addPriceValidationSchema = (
  mode?: (typeof PRICE_COMPONENT_MODES)[keyof typeof PRICE_COMPONENT_MODES]
) =>
  Yup.object().shape({
    categoryId: Yup.string().required('Category is required'),
    categoryName: Yup.string().required(),

    doctorId: Yup.string().when('categoryName', {
      is: (val: string) =>
        val === 'Consultation' &&
        mode !== PRICE_COMPONENT_MODES.EDIT_PRICE_MODE,
      then: schema => schema.required('Consultant is required'),
    }),
    consultationFee: Yup.string().when('categoryName', {
      is: 'Consultation',
      then: schema => schema.required('Fee required'),
    }),
    followupFee: Yup.string().when('categoryName', {
      is: 'Consultation',
      then: schema => schema.required('Follow up fee required'),
    }),

    ccsdCode: Yup.string(),

    description: Yup.string().when('categoryName', {
      is: (val: string) => val !== 'Consultation',
      then: schema => schema.required('Description required'),
    }),
    price: Yup.string().when('categoryName', {
      is: (val: string) => val !== 'Consultation',
      then: schema => schema.required('Price required'),
    }),

    eyeOption: Yup.string().when('categoryName', {
      is: (val: string) =>
        [
          'Refractive/Cataract',
          'Add-ons',
          'Retinal',
          'Oculoplastics and Lacrimal',
          'Corneal and Conjunctival',
        ].includes(val),
      then: schema => schema.required('Eye Option required'),
    }),
  });
